<template>
  <div>
    <v-toolbar>
      <v-toolbar-items align="center">
        <div class="px-2 pt-3 px-lg-10 pr-lg-16 py-lg-5">
          <div class="b1">
            <router-link
              to="/"
              class="b1 link hidden-sm-and-down"
              :class="{ currentRout: home }"
              >{{ $t("home") }}</router-link
            >
            <router-link
              to="/"
              class="b1 link font14 d-lg-none"
              :class="{ currentRout: home }"
              >{{ $t("home") }}</router-link
            >
          </div>
          <div
            class="row d-flex justify-content-center h1 blue-text mt-lg-n6 mt-n4"
          >
            <div :class="{ block: home, none: !home }">.</div>
          </div>
        </div>
        <div class="px-2 pt-3 px-lg-10 py-lg-5">
          <div class="b1">
            <router-link
              class="link b1 hidden-sm-and-down"
              to="/contactUs"
              :class="{ currentRout: contactUs }"
              >{{ $t("contact-us") }}</router-link
            >
            <router-link
              class="link b1 font14 d-lg-none"
              to="/contactUs"
              :class="{ currentRout: contactUs }"
              >{{ $t("contact-us") }}</router-link
            >
          </div>
          <div
            class="row d-flex justify-content-center h1 blue-text mt-lg-n6 mt-n4"
          >
            <div :class="{ block: contactUs, none: !contactUs }">.</div>
          </div>
        </div>
        <div class="px-2 pt-3 px-lg-10 py-lg-5">
          <div class="b1">
            <router-link
              to="/aboutUs"
              class="link b1 hidden-sm-and-down"
              :class="{ currentRout: aboutUs }"
              >{{ $t("about-us") }}</router-link
            >
            <router-link
              to="/aboutUs"
              class="link b1 font14 d-lg-none"
              :class="{ currentRout: aboutUs }"
              >{{ $t("about-us") }}</router-link
            >
          </div>
          <div
            class="row d-flex justify-content-center h1 blue-text mt-lg-n6 mt-n4"
          >
            <div :class="{ block: aboutUs, none: !aboutUs }">.</div>
          </div>
        </div>
      </v-toolbar-items>
      <v-spacer></v-spacer>
      <span class="mx-8 hidden-sm-and-down">
        <span>{{ $t("contact-phone") }}</span>
        <v-icon>mdi-phone</v-icon></span
      >
      <v-toolbar-title v-if="showPanelBtn"
        ><router-link class="link" to="/panelOrderHistory"
          ><div
            class="font14 px-3 py-1 pnel-btn text-light b1 btn-radio mx-lg-8 mx-1"
          >
            {{ $t("panel") }}
          </div></router-link
        ></v-toolbar-title
      >
      <v-toolbar-title v-if="showSignBtn"
        ><router-link class="link" to="/sign"
          ><v-btn class="blue-bcg text-light b1 btn-radio mx-lg-8 mx-1">{{
            $t("sign/log")
          }}</v-btn></router-link
        ></v-toolbar-title
      >
      <v-toolbar-title v-if="showExitBtn"
        ><router-link class="link" to="/"
          ><div
            class="font14 px-3 py-1 p-lg-5 lg-h1 b1 btn-radio mx-lg-8 mx-1 red-text red-border"
            @click="clearSession()"
          >
            {{ $t("exit") }}
          </div></router-link
        ></v-toolbar-title
      >
    </v-toolbar>
  </div>
</template>
<script>
export default {
  data() {
    return {
      showSignBtn: false,
      showExitBtn: false,
      showPanelBtn: false,
      // drawer: false,
      // SmenueH: 0,
      home: false,
      aboutUs: false,
      contactUs: false,
    };
  },
  methods: {
    clearSession() {
      this.$session.clear();
      this.axios.defaults.headers.common["Authorization"] =
        "Bearer " + this.$session.get("token");
      this.axios.get("logout");
    },
  },
  mounted() {
    this.axios.defaults.headers.common["Authorization"] =
      "Bearer " + this.$session.get("token");
    if (this.$session.get("login")) {
      this.showPanelBtn = true;
      this.showSignBtn = false;
      this.showExitBtn = false;
    } else {
      this.showPanelBtn = false;
      this.showSignBtn = true;
      this.showExitBtn = false;
    }
    if (
      this.$router.history.current.path == "/panelInfo" ||
      this.$router.history.current.path == "/panelComment" ||
      this.$router.history.current.path == "/panelRecivers" ||
      this.$router.history.current.path == "/panelOrderHistory" ||
      this.$router.history.current.path == "/panelNewOrder"
    ) {
      this.showExitBtn = true;
      this.showPanelBtn = false;
      this.showSignBtn = false;
    }
    if (this.$router.history.current.path == "/") {
      this.home = true;
      this.aboutUs = false;
      this.contactUs = false;
    }
    if (this.$router.history.current.path == "/aboutUs") {
      this.aboutUs = true;
      this.home = false;
      this.contactUs = false;
    }
    if (this.$router.history.current.path == "/contactUs") {
      this.contactUs = true;
      this.aboutUs = false;
      this.home = false;
    }
  },
};
</script>
<style scoped>
.pnel-btn {
  background-color: #2a9d8f !important;
}
.transition {
  transition: 1s;
}
.currentRout {
  color: #3c56c8 !important;
}
</style>
